var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diagram-frequency-sec"},[_c('p',{staticClass:"diagram-frequency-sec__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._l((_vm._frequencySec),function(frequency,frequencyIndex){return _c('p',{key:frequencyIndex,staticClass:"diagram-frequency-sec__text"},[_vm._v(" "+_vm._s(frequency)+_vm._s(_vm.unit)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }